import React, { useEffect, useState } from "react";
import AppHeader from "./AppHeader";
import { Outlet, useNavigate } from "react-router-dom";
import AppFooter from "./AppFooter";
import { useAuth } from "../../hooks/useAuth";
import { user_init_api } from "../../DAL/Users";
import toast from "react-hot-toast";
import PageLoader from "../../Components/GeneralComponents/PageLoader";

export default function HomeLayout() {
  const [isLoading, setIsLoading] = useState(true);
  const { setUserInfo } = useAuth();
  const navigate = useNavigate();

  const handleGetInfo = async () => {
    const result = await user_init_api();
    if (result.code === 200) {
      setUserInfo((old) => ({ ...old, ...result.data }));
      setIsLoading(false);
    } else {
      setIsLoading(false);
      toast.error(`${result.message}`);
    }
  };

  useEffect(() => {
    if (localStorage.getItem("token")) {
      handleGetInfo();
    } else {
      navigate("/login");
    }
  }, []);

  if (isLoading) {
    return <PageLoader height="100vh" />;
  }

  return (
    <div className="d-flex flex-column min-vh-100">
      <AppHeader />
      <main
        className="flex-fill py-5"
        style={{
          background: "linear-gradient(135deg, #f5f7fa 0%, #e9ecef 100%)",
        }}
      >
        <Outlet />
      </main>
      <AppFooter />
    </div>
  );
}
